<script setup>
// import { ref } from 'vue';
import TenderTable from "./Tables/TenderTable.vue";

</script>
<template>
<div class="py-4 container-fluid ">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-header pb-0">
                <h6>Tender</h6>
                </div>
                <div class="py-4 container-fluid">
                    <div class="row ">
                        <div class="col-md-4">
                            <label for="example-text-input" class="form-control-label text-danger">Website URL</label>
                            <input class="form-control" v-model="model.tender.website" id="input_website" type="text" placeholder="http://admin.acjnursery.com" />
                        </div>
                        <div class="col-md-4">
                            <label for="example-text-input" class="form-control-label text-danger">Website Name</label>
                            <input type="text" id="input_websitename" v-model="model.tender.websitename" class="form-control">
                        </div>
                        <div class="col-md-4">
                            <label for="example-text-input" class="form-control-label">Contact</label>
                            <input type="text" id="input_contact" v-model="model.tender.contact" class="form-control">
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Email</label>
                            <input type="text" id="input_date" v-model="model.tender.email" class="form-control">
                        </div>
                        <div class="col-md-3">
                            <label for="example-text-input" class="form-control-label">Company</label>
                            <input type="text" id="input_date" v-model="model.tender.company" class="form-control">
                        </div>
                        <div class="col-md-6">
                            <label for="example-text-input" class="form-control-label">Remark</label>
                            <input type="text" id="input_date" v-model="model.tender.remark" class="form-control">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <button class="btn btn-success mt-3" type="button" @click="addTenderWebsite" style="float: right;" id="btn_add">Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="mt-4 row">
        <div class="col-12">
            <TenderTable :key="componentKey" />
        </div>
    </div>
</div>

</template>


<script>
import axios from 'axios';
export default {
    name:'AddTender',
    data(){
        return {
            componentKey: 0,
        //   errorList: '',
        model:{
            tender:{
                website:'',
                websitename:'',
                remark:'',
                contact: '',
                email:'',
                company:''
            },
            sewaProfile:[]
    
        }
        }
    },
    methods: {
        addTenderWebsite(){
            // var mythis = this;
            // console.log(this.model.sewaPajak);
            axios.post('tender/addTenderWebsite',this.model.tender)
                .then(res => {
                    alert(res.data.message);
                    this.model.tender = {
                        website:'',
                        websitename:'',
                        remark:'',
                        contact: '',
                        email:'',
                        company:''
                    };
                    this.componentKey += 1;
                }).catch(function (error){
                    if(error.response){
                        if(error.response.status == 422){
                            alert('Error: Address, Date, and Amount is required! ');
                        }
                    }else if(error.request){
                        console.log(error.request);
                    }else{
                        console.log('Error',error.message);
                    }
                });
        }
    }
}
</script>